import { render, staticRenderFns } from "./courseIntro.vue?vue&type=template&id=5607244a&scoped=true&"
import script from "./courseIntro.vue?vue&type=script&lang=js&"
export * from "./courseIntro.vue?vue&type=script&lang=js&"
import style0 from "./courseIntro.vue?vue&type=style&index=0&id=5607244a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5607244a",
  null
  
)

export default component.exports